interface customerDataType {
    id, pdasId: number,
    name, email, country: string,
};

// export const customerData:customerDataType = {
//     id : null,
//     name : '',
//     email : '',
//     country  : '',
//     pdasId : null
// };

// countries.
interface countriesType {
    id, selected: number,
    title, code, hdLogo, logo: string,
}

export const countries: countriesType[] = [
    {
        title: 'Ghana',
        code: '+233',
        id: 1,
        logo: 'assets/images/flags/ghana.png',
        hdLogo: 'assets/images/flags/ghanaHD.png',
        selected: 0
    },
    {
        title: 'Nigeria',
        code: '+234',
        id: 2,
        logo: 'assets/images/flags/nigeria.png',
        hdLogo: 'assets/images/flags/nigeriaHD.png',
        selected: 0
    }
]


interface deliveryMethodsType {
    title, icon, currency, distance, estimateTime, type, label?, cashBack: string,
    isSelected, id, canUsePdasWalletAmount, canUseWallet, convenienceFee, subId?, damageCoverAmount, discountAmount, discountinpercentage, grossTotal, isPdasCommisionApplied, isRecommended, loadingFee, netTotal, pdasCommisionPercentage, pdasWalletAmount, totalCharges, walletAmt, walletPercentage, notSelectable?: number,
}

export const deliveryMethods: deliveryMethodsType[] = [
    // Bicycle for 'ghana'
    {
        id: 1,
        title: 'Bicycle',
        icon: 'assets/images/bulkOrder/deliveryMethod/bicycle.svg',
        isSelected: 0,
        notSelectable: 0,
        // update these value by firebase.
        currency: '',
        canUsePdasWalletAmount: null,
        canUseWallet: null,
        cashBack: '',
        convenienceFee: null,
        damageCoverAmount: null,
        discountAmount: null,
        discountinpercentage: null,
        distance: '',
        estimateTime: '',
        grossTotal: null,
        isPdasCommisionApplied: null,
        isRecommended: null,
        loadingFee: null,
        netTotal: null,
        pdasCommisionPercentage: null,
        pdasWalletAmount: null,
        totalCharges: null,
        type: '',
        walletAmt: null,
        walletPercentage: null
    },

    // MotorBike for 'ghana' & for 'ng' it's for selective item type 'packaged', 'care'
    {
        id: 2,
        title: 'MotorBike',
        label: 'Standard',
        icon: 'assets/images/bulkOrder/deliveryMethod/motorBike.svg',
        isSelected: 0,
        notSelectable: null,
        // update these value by firebase.
        currency: '',
        canUsePdasWalletAmount: null,
        canUseWallet: null,
        cashBack: '',
        convenienceFee: null,
        damageCoverAmount: null,
        discountAmount: null,
        discountinpercentage: null,
        distance: '',
        estimateTime: '',
        grossTotal: null,
        isPdasCommisionApplied: null,
        isRecommended: null,
        loadingFee: null,
        netTotal: null,
        pdasCommisionPercentage: null,
        pdasWalletAmount: null,
        totalCharges: null,
        type: '',
        walletAmt: null,
        walletPercentage: null
    },

    // 'SUB' MotorBike
    {
        id: 7,
        title: 'MotorBike',
        label: 'Saver',
        icon: 'assets/images/bulkOrder/deliveryMethod/saver.svg',
        isSelected: 0,
        notSelectable: null,
        // update these value by firebase.
        currency: '',
        canUsePdasWalletAmount: null,
        canUseWallet: null,
        cashBack: '',
        convenienceFee: null,
        damageCoverAmount: null,
        discountAmount: null,
        discountinpercentage: null,
        distance: '',
        estimateTime: '',
        grossTotal: null,
        isPdasCommisionApplied: null,
        isRecommended: null,
        loadingFee: null,
        netTotal: null,
        pdasCommisionPercentage: null,
        pdasWalletAmount: null,
        totalCharges: null,
        type: '',
        walletAmt: null,
        walletPercentage: null
    },


    // Car for 'ghana' & 'ng' for all case
    {
        id: 3,
        title: 'Car',
        icon: 'assets/images/bulkOrder/deliveryMethod/car.png',
        isSelected: 0,
        notSelectable: null,

        // update these value by firebase.
        currency: '',
        canUsePdasWalletAmount: null,
        canUseWallet: null,
        cashBack: '',
        convenienceFee: null,
        damageCoverAmount: null,
        discountAmount: null,
        discountinpercentage: null,
        distance: '',
        estimateTime: '',
        grossTotal: null,
        isPdasCommisionApplied: null,
        isRecommended: null,
        loadingFee: null,
        netTotal: null,
        pdasCommisionPercentage: null,
        pdasWalletAmount: null,
        totalCharges: null,
        type: '',
        walletAmt: null,
        walletPercentage: null
    },

    // Van for 'ng'
    {
        id: 4,
        title: 'Van',
        icon: 'assets/images/bulkOrder/deliveryMethod/van.svg',
        isSelected: 0,
        notSelectable: null,

        // update these value by firebase.
        currency: '',
        canUsePdasWalletAmount: null,
        canUseWallet: null,
        cashBack: '',
        convenienceFee: null,
        damageCoverAmount: null,
        discountAmount: null,
        discountinpercentage: null,
        distance: '',
        estimateTime: '',
        grossTotal: null,
        isPdasCommisionApplied: null,
        isRecommended: null,
        loadingFee: null,
        netTotal: null,
        pdasCommisionPercentage: null,
        pdasWalletAmount: null,
        totalCharges: null,
        type: '',
        walletAmt: null,
        walletPercentage: null
    },

    // Truck for 'ng' 'heavy items'
    {
        id: 5,
        // title: 'Truck',
        title: 'PickUp Truck',  // for ghana 'Abossey Okai Macho (PickUp Truck)'
        // icon: 'assets/images/bulkOrder/deliveryMethod/largeTruck.png',
        icon: 'assets/images/bulkOrder/deliveryMethod/pickup.svg',
        isSelected: 0,
        notSelectable: null,
        // update these value by firebase.
        currency: '',
        canUsePdasWalletAmount: null,
        canUseWallet: null,
        cashBack: '',
        convenienceFee: null,
        damageCoverAmount: null,
        discountAmount: null,
        discountinpercentage: null,
        distance: '',
        estimateTime: '',
        grossTotal: null,
        isPdasCommisionApplied: null,
        isRecommended: null,
        loadingFee: null,
        netTotal: null,
        pdasCommisionPercentage: null,
        pdasWalletAmount: null,
        totalCharges: null,
        type: '',
        walletAmt: null,
        walletPercentage: null
    },

    // Mini Van for 'ng' 'heavy items'
    {
        id: 6,
        // title: 'Mini Van',
        title: 'Mini Van', // for ghana 'Cargo Van'
        // icon: 'assets/images/bulkOrder/deliveryMethod/largeMiniVan.png',
        icon: 'assets/images/bulkOrder/deliveryMethod/truck.svg',
        isSelected: 0,
        notSelectable: null,

        // update these value by firebase.
        currency: '',
        canUsePdasWalletAmount: null,
        canUseWallet: null,
        cashBack: '',
        convenienceFee: null,
        damageCoverAmount: null,
        discountAmount: null,
        discountinpercentage: null,
        distance: '',
        estimateTime: '',
        grossTotal: null,
        isPdasCommisionApplied: null,
        isRecommended: null,
        loadingFee: null,
        netTotal: null,
        pdasCommisionPercentage: null,
        pdasWalletAmount: null,
        totalCharges: null,
        type: '',
        walletAmt: null,
        walletPercentage: null
    },
];


interface handlingMethodsType {
    title, icon, for?: string,
    isSelected, id: number
}

export const handlingMethods: handlingMethodsType[] = [
    {
        id: 1,
        title: 'Packaged',
        icon: 'assets/images/bulkOrder/handlingMethod/packaged.png',
        isSelected: 0,
    },
    {
        id: 2,
        title: 'Handle With Care ',
        icon: 'assets/images/bulkOrder/handlingMethod/handleWithCare.png',
        isSelected: 0,
    },
    {
        id: 3,
        title: 'Heavy Items',
        icon: 'assets/images/bulkOrder/handlingMethod/heavyItem.png',
        isSelected: 0,
    },
    {
        id: 4,
        title: 'Relocation',
        icon: 'assets/images/bulkOrder/handlingMethod/relocate.png',
        isSelected: 0,
    }
];

export const handlingMethodsForRegional: handlingMethodsType[] = [
    {
        id: 1,
        title: 'Packaged',
        icon: 'assets/images/bulkOrder/handlingMethod/packaged.png',
        isSelected: 0,
    },
    {
        id: 2,
        title: 'Handle With Care ',
        icon: 'assets/images/bulkOrder/handlingMethod/handleWithCare.png',
        isSelected: 0,
    },
];

interface locationType {
    contactPerson, pickupAddress, near, personNumber: string,
}

export const locations: locationType[] = [
    {
        contactPerson: 'Eric Johnson',
        pickupAddress: '5 Fifth Link Rd, Accra, Ghana',
        near: 'Landmark near you',
        personNumber: '+233 24 243 6000'
    },
    {
        contactPerson: 'Peter Jackson',
        pickupAddress: 'Casely Hayford Rd, Accra, Ghana',
        near: 'Landmark near you',
        personNumber: '+233 24 243 6000'
    },
    {
        contactPerson: 'Micheal Jordan',
        pickupAddress: '66 Gamel Abdul Nasser Ave, Accra, Ghana',
        near: 'Landmark near you',
        personNumber: '+233 24 243 6000'
    }
]

interface paymentMethodType {
    id, isSelected, type?, amount?, isRecommended: number,
    subTitle?, title, icon, selectedIcon, curency?: string,
}

export const paymentMethods: paymentMethodType[] = [
    {
        id: 1,
        title: 'cash',
        icon: 'assets/images/icons/cash.png',
        selectedIcon: 'assets/images/icons/casha.png',
        isSelected: 0,
        isRecommended: 0
    },
    {
        id: 2,
        title: 'online',
        icon: 'assets/images/icons/online.png',
        selectedIcon: 'assets/images/icons/onlinea.png',
        isSelected: 0,
        isRecommended: 1
    },
    {
        id: 3,
        title: 'Phlenu Wallet',
        icon: 'assets/images/icons/phlenuWallet.png',
        selectedIcon: 'assets/images/icons/phlenuWalleta.png',
        // curency : 'GHS',
        // amount : 150,

        isSelected: 0,
        isRecommended: 1
    }
]

export const bulkPaymentMethods: paymentMethodType[] = [
    // {
    //     id : 1,
    //     title : 'cash',
    //     icon : 'assets/images/icons/cash.png',
    //     selectedIcon : 'assets/images/icons/casha.png',
    //     isSelected : 0,
    //     isRecommended : 0
    // },
    {
        id: 1,
        type: 1,
        title: 'Cash on Pickup',
        icon: 'assets/images/icons/cashOnPickup.png',
        selectedIcon: 'assets/images/icons/cashOnPickupa.png',
        isSelected: 0,
        isRecommended: 0
    },
    {
        id: 2,
        type: 2,
        title: 'Cash on Delivery',
        icon: 'assets/images/icons/cashOnDelivery.png',
        selectedIcon: 'assets/images/icons/cashOnDeliverya.png',
        isSelected: 0,
        isRecommended: 0
    },
    {
        id: 3,
        type: 3,
        title: 'online',
        icon: 'assets/images/icons/online.png',
        selectedIcon: 'assets/images/icons/onlinea.png',
        isSelected: 0,
        isRecommended: 1
    },
    {
        id: 4,
        type: 3,
        title: 'Phlenu Wallet',
        icon: 'assets/images/icons/phlenuWallet.png',
        selectedIcon: 'assets/images/icons/phlenuWalleta.png',
        // curency : 'GHS',
        // amount : 150,

        isSelected: 0,
        isRecommended: 1
    }
]


export const interRegionalOrderPayment: paymentMethodType[] = [
    // {
    //     id : 1,
    //     title : 'cash',
    //     icon : 'assets/images/icons/cash.png',
    //     selectedIcon : 'assets/images/icons/casha.png',
    //     isSelected : 0,
    //     isRecommended : 0
    // },

    {
        id: 1,
        type: 1,
        title: 'Pay After Sale',
        subTitle: 'Delivery fee will be deducted after your item is sold and delivered',
        icon: 'assets/images/icons/cashOnPickup.png',
        selectedIcon: 'assets/images/icons/cashOnPickupa.png',
        isSelected: 0,
        isRecommended: 0
    },


    {
        id: 1,
        type: 1,
        title: 'Cash on Pickup',
        icon: 'assets/images/icons/cashOnPickup.png',
        selectedIcon: 'assets/images/icons/cashOnPickupa.png',
        isSelected: 0,
        isRecommended: 0
    },
    {
        id: 2,
        type: 2,
        title: 'Cash on Delivery',
        icon: 'assets/images/icons/cashOnDelivery.png',
        selectedIcon: 'assets/images/icons/cashOnDeliverya.png',
        isSelected: 0,
        isRecommended: 0
    },
    {
        id: 3,
        type: 3,
        title: 'online',
        icon: 'assets/images/icons/online.png',
        selectedIcon: 'assets/images/icons/onlinea.png',
        isSelected: 0,
        isRecommended: 0
    },
    {
        id: 4,
        type: 3,
        title: 'Phlenu Wallet',
        icon: 'assets/images/icons/phlenuWallet.png',
        selectedIcon: 'assets/images/icons/phlenuWalleta.png',
        isSelected: 0,
        isRecommended: 0
    }
]


interface cashSeriveType {
    id, isSelected: number,
    title, icon, selectedIcon: string,
}

export const cashSerive: cashSeriveType[] = [
    {
        id: 1,
        title: 'Cash on Pickup',
        icon: 'assets/images/icons/cashOnPickup.png',
        selectedIcon: 'assets/images/icons/cashOnPickupa.png',
        isSelected: 0
    },
    {
        id: 2,
        title: 'Cash on Delivery',
        icon: 'assets/images/icons/cashOnDelivery.png',
        selectedIcon: 'assets/images/icons/cashOnDeliverya.png',
        isSelected: 0
    }
]

// for How did you hear of phlenu ? field.
type Source = | "Radio" | "TV" | "Facebook" | "Instagram" | "Twitter" | "Youtube" | "Billboard" | "Word of Mouth" | "Referral From Friend/Colleague" | "Phlenu Employees" | "Influencers" | "Tiktok" | "Snapchat" | "Third-party Websites" | "Other";

export const sourceList: Source[] = [
    "Radio", "TV", "Facebook", "Instagram", "Twitter", "Youtube", "Billboard", "Word of Mouth", "Referral From Friend/Colleague", "Phlenu Employees", "Influencers", "Tiktok", "Snapchat", "Third-party Websites", "Other"
];

interface vehicleType {
    id: number,
    title, icon: string
}

export const vehicleType: vehicleType[] = [
    // Bicycle for 'ghana'
    {
        id: 1,
        title: 'Bicycle',
        icon: 'assets/images/bulkOrder/deliveryMethod/bicycle.svg',
    },

    // MotorBike for 'ghana' & for 'ng' it's for selective item type 'packaged', 'care'
    {
        id: 2,
        title: 'MotorBike',
        icon: 'assets/images/bulkOrder/deliveryMethod/motorBike.svg',
    },

    // Car for 'ghana' & 'ng' for all case
    {
        id: 3,
        title: 'Car',
        icon: 'assets/images/bulkOrder/deliveryMethod/car.png',
    },

    // Van for 'ng'
    {
        id: 4,
        title: 'Van',
        icon: 'assets/images/bulkOrder/deliveryMethod/largeVan.png',
    },

    // Truck for 'ng' 'heavy items'
    {
        id: 5,
        title: 'Truck',
        icon: 'assets/images/bulkOrder/deliveryMethod/largePickup.png',
    },

    // Mini Van for 'ng' 'heavy items'
    {
        id: 6,
        title: 'Mini Van',
        icon: 'assets/images/bulkOrder/deliveryMethod/largeTruck.png',
    },
]

interface PDAS_CANCEL_REASON {
    id: number, title: string
}

export const PDASCANCELREASONS: PDAS_CANCEL_REASON[] = [
    { id: 1, title: 'Delivery personnel too far.' },
    { id: 2, title: 'Delivery personnel has fewer rating.' },
    { id: 3, title: 'Delivery personnel did not answer phone/chat.' },
    { id: 4, title: 'Delivery personnel has an incorrect vehicle description.' },
    { id: 5, title: 'Safety concerns.' },
    { id: 6, title: 'Waited for too long.' },
    { id: 7, title: 'Pickup not available.' },
    { id: 8, title: 'Drop off not available.' },
    { id: 9, title: 'Delivery personnel had an accident/mechanical issues.' },
    { id: 10, title: 'Other (please specify).' },
]

export interface Coordinates {
    latitude: number, longitude: number
}

export const trackVehicleImages = [
    // Bicycle for 'ghana'
    {
        id: 1,
        title: 'Bicycle',
        icon: 'assets/images/tracking/pin_bicycle.png',
    },

    // MotorBike for 'ghana' & for 'ng' it's for selective item type 'packaged', 'care'
    {
        id: 2,
        title: 'MotorBike',
        icon: 'assets/images/tracking/bike_pin.png',
    },

    // Car for 'ghana' & 'ng' for all case
    {
        id: 3,
        title: 'Car',
        icon: 'assets/images/tracking/pin_car.png',
    },

    // Van for 'ng'
    {
        id: 4,
        title: 'Van',
        icon: 'assets/images/tracking/pin_miniVan.png',
    },

    // Truck for 'ng' 'heavy items'
    {
        id: 5,
        title: 'Truck',
        icon: 'assets/images/tracking/pin_pickup.png',
    },

    // Mini Van for 'ng' 'heavy items'
    {
        id: 6,
        title: 'Mini Van',
        icon: 'assets/images/tracking/pin_truck.png',
    },
]

interface STARIMAGETYPE {
    oneStar, twoStar, threeStar, fourStar, fiveStar: string
}

export const StarImages: STARIMAGETYPE = {
    oneStar: 'assets/images/ui/stars/oneStar.png',
    twoStar: 'assets/images/ui/stars/twoStar.png',
    threeStar: 'assets/images/ui/stars/threeStar.png',
    fourStar: 'assets/images/ui/stars/fourStar.png',
    fiveStar: 'assets/images/ui/stars/fiveStar.png'
}

/* 
    PACKSIZE DATA FOR BULK ORDER
*/
interface packageImageType {
    packageSmall?, packageMedium?, LightHeavy?, packageLarge?, packageXLarge?, packageVariable?, lightWeight?, regular?, bulky?, heavyWeight?, superHeavy?: string
}

export interface PACKAGESIZETYPE {
    id, name, info, icon, desc: string,
    isSelected: number
}

// export const packageSizes:PACKAGESIZETYPE[] = [
//     { id: 1, name: 'Small', info: 'up to 2kg', isSelected : 0, icon: packageImage.packageSmall, desc: 'Ideal for documents, small parcels, and gifts.' },
//     { id: 2, name: 'Medium', info: '2kg to 10kg', isSelected : 0, icon: packageImage.packageMedium, desc: 'Suitable for medium-sized parcels, larger gifts, and small equipment.' },
//     { id: 3, name: 'Large', info: '10kg to 30kg', isSelected : 0, icon: packageImage.packageLarge, desc: 'Perfect for bulk goods, larger equipment, and substantial shipments.' },
//     { id: 4, name: 'Extra Large', info: 'over 30kg', isSelected : 0, icon: packageImage.packageXLarge, desc: 'For oversized items, heavy equipment, and major bulk shipments.' },
//     { id: 5, name: 'Variable Weight', info: ' ', isSelected : 0, icon: packageImage.packageVariable, desc: 'For shipments with mixed sizes or special requirements.' },
// ];

interface phlenuSupportWhatsappType {
    ghana, nigeria: string
}

export const phlenuSupportWhatsapp: phlenuSupportWhatsappType = {
    ghana: '+233554867581',
    nigeria: '+2348183919123'
};

export const bulkPackageImage: packageImageType = {
    packageSmall: 'assets/images/packageSizes/bulk/packageSmall.png',
    packageMedium: 'assets/images/packageSizes/bulk/packageMedium.png',
    packageLarge: 'assets/images/packageSizes/bulk/packageLarge.png',
    packageXLarge: 'assets/images/packageSizes/bulk/packageXLarge.png',
    packageVariable: 'assets/images/packageSizes/bulk/packageVariable.png'
}

export const bulkPackageSizes: PACKAGESIZETYPE[] = [
    { id: 1, name: 'Small', info: 'up to 2kg', icon: bulkPackageImage.packageSmall, isSelected: 0, desc: 'Ideal for documents, small parcels, and gifts.' },
    { id: 2, name: 'Medium', info: '2kg to 10kg', icon: bulkPackageImage.packageMedium, isSelected: 0, desc: 'Suitable for medium-sized parcels, larger gifts, and small equipment.' },
    { id: 3, name: 'Large', info: '10kg to 30kg', icon: bulkPackageImage.packageLarge, isSelected: 0, desc: 'Perfect for bulk goods, larger equipment, and substantial shipments.' },
    { id: 4, name: 'Extra Large', info: 'over 30kg', icon: bulkPackageImage.packageXLarge, isSelected: 0, desc: 'For oversized items, heavy equipment, and major bulk shipments.' },
    { id: 5, name: 'Variable Weight', info: ' ', icon: bulkPackageImage.packageVariable, isSelected: 0, desc: 'For shipments with mixed sizes or special requirements.' },
];

export const standardPackageImage: packageImageType = {
    lightWeight: 'assets/images/packageSizes/standard/lightWeight.png',
    LightHeavy: 'assets/images/packageSizes/standard/lightHeavy.png',
    regular: 'assets/images/packageSizes/standard/regular.png',
    bulky: 'assets/images/packageSizes/standard/bulky.png',
    superHeavy: 'assets/images/packageSizes/standard/superHeavy.png',
    heavyWeight: 'assets/images/packageSizes/standard/heavyWeight.png',

}

export const interRegionalPackageSizes: PACKAGESIZETYPE[] = [
    { id: 1, name: 'Small', info: 'up to 2kg', icon: bulkPackageImage.packageSmall, isSelected: 0, desc: 'Ideal for documents, small parcels, and gifts.' },
    { id: 2, name: 'Medium', info: '2kg to 10kg', icon: bulkPackageImage.packageMedium, isSelected: 0, desc: 'Suitable for medium-sized parcels, larger gifts, and small equipment.' },
    { id: 3, name: 'Large', info: '10kg to 30kg', icon: bulkPackageImage.packageLarge, isSelected: 0, desc: 'Perfect for bulk goods, larger equipment, and substantial shipments.' },
    // { id: 4, name: 'Extra Large', info: 'over 30kg', icon: bulkPackageImage.packageXLarge, isSelected: 0, desc: 'For oversized items, heavy equipment, and major bulk shipments.' },
    // { id: 5, name: 'Variable Weight', info: ' ', icon: bulkPackageImage.packageVariable, isSelected: 0, desc: 'For shipments with mixed sizes or special requirements.' },
];


export const standardPackageSizes: PACKAGESIZETYPE[] = [
    { id: 1, name: 'Light Weight', info: '96-150 kg', icon: standardPackageImage.lightWeight, isSelected: 0, desc: 'Ideal for transporting small yet sturdy lightweight items' },
    { id: 6, name: 'Light Heavy', info: '151 - 250 kg', icon: standardPackageImage.LightHeavy, isSelected: 0, desc: 'Perfect for handling moderately heavy loads with care and efficiency' },
    { id: 2, name: 'Regular', info: '251-500 kg', icon: standardPackageImage.regular, isSelected: 0, desc: 'Perfect for regular-sized shipments.' },
    { id: 3, name: 'Bulky', info: '501-750 kg', icon: standardPackageImage.bulky, isSelected: 0, desc: 'Suitable for larger loads.' },
    { id: 4, name: 'Super Heavy', info: '751-1000 kg', icon: standardPackageImage.superHeavy, isSelected: 0, desc: 'Ideal for substantial relocation needs and oversized loads.' },
    { id: 5, name: 'Heavy Weight', info: '1001 kg and above', icon: standardPackageImage.heavyWeight, isSelected: 0, desc: 'Best for heavy, bulk shipments.' },
];